export default "__VITE_ASSET__BEiZfBZ3__"